import { render, staticRenderFns } from "./PortalPage.vue?vue&type=template&id=54c13f9a&"
import script from "./PortalPage.vue?vue&type=script&lang=js&"
export * from "./PortalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c13f9a')) {
      api.createRecord('54c13f9a', component.options)
    } else {
      api.reload('54c13f9a', component.options)
    }
    module.hot.accept("./PortalPage.vue?vue&type=template&id=54c13f9a&", function () {
      api.rerender('54c13f9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/PortalPage.vue"
export default component.exports